module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vgal10-c12597006847d137a982cbe9a430feea.jpg";